import React from 'react';

const NextButton = ({onClick}) => {
    return (
        <button 

            onClick={onClick}
            style={{
                height: '42px',
                width: '120px',
                backgroundColor: 'red',
                color: 'white',
                borderRadius: '25px',
                border: 'none',
                margin:'20px',
                fontSize: '16px',
            }}
        >
            Next
        </button>
    );
};

export default NextButton;